export const VALID_PAYMENT_GROUP_TYPES = {
    CARD: "CARD",
    COD: "COD",
    FOOD_CARD: "FOOD_CARD",
    NETBANKING: "NETBANKING",
    PAY_LATER: "PAY_LATER",
    PREFERRED: "PREFERRED",
    UPI: "UPI",
    INAPP_UPI: "INAPP_UPI",
    WALLET: "WALLET",
    WALLET_WEB: "WALLET_WEB",
    SWIGGY_INSTRUMENTS: "SWIGGY_INSTRUMENTS",
    CRED: "CRED",
    SINGLE_CLICK: "SINGLE_CLICK",
    EXTRA_OFFERS: "EXTRA_OFFERS",
    FLIPKART_SUPER_COIN: "FLIPKART_SUPER_COIN",
    EMI: "EMI",
    REWARDS: "REWARDS",
    BILL_TO_COMPANY: "BILL_TO_COMPANY",
};

export const VALID_PAYMENT_METHODS = {
    CARD: "CARD",
    COD: "COD",
    NETBANKING: "NETBANKING",
    NEW_CARD: "NEW_CARD",
    NEW_FOOD_CARD: "NEW_FOOD_CARD",
    NEW_UPI: "NEW_VPA",
    PAYLATER: "PAYLATER",
    SWIGGY_MONEY: "SWIGGY_MONEY",
    SWIGGYPAY: "SWIGGYPAY",
    UPI: "UPI",
    NEW_INAPP_UPI: "NEW_INAPP_UPI_INSTRUMENT",
    NEW_INAPP_UPI_ONBOARDING: "NEW_INAPP_UPI_ONBOARDING",
    INAPP_UPI: "INAPP_UPI",
    WALLET: "WALLET",
    WALLET_WEB: "WALLET_WEB",
    CRED: "CRED",
    FLIPKART_SUPER_COIN: "FLIPKART_SUPER_COIN",
    MMT: "MMT",
    POD: "POD",
};

export const PAYMENT_CODES = {
    NETBANKING: "Juspay-NB",
    JUSPAY: "Juspay",
    UPICOLLECT: "UPICollect",
    UPIINTENT: "UPIIntent",
    INAPPUPI: "InAppUPI",
    AMAZONPAYWEB: "AmazonPayWeb",
    AMAZONPAY: "AmazonPay",
    AMAZONPAYLATER: "AmazonPayLater",
    PHONEPE: "PhonePe",
    CRED: "Cred",
    PHONEPEUPI: "PhonePeUPI",
    CASH: "Cash",
    PAYTM: "PayTM-SSO",
    MOBIKWIK: "Mobikwik-SSO",
    FREECHARGE: "Freecharge-SSO",
    BNPL: "BNPL",
    SWIGGYPAY: "SwiggyPay",
    FLIPKART_SUPER_COIN: "FlipkartSuperCoin",
    THIRD_PARTY_EMI: "Third-Party-EMI",
    TWID_REWARD: "TwidRewards",
    MMT: "Mmt",
};

export const VALID_UPI_PAYMENT_CODE = {
    UPI_INTENT: PAYMENT_CODES.UPIINTENT.toUpperCase(),
    UPI_COLLECT: PAYMENT_CODES.UPICOLLECT.toUpperCase(),
    PHONEPE_UPI: PAYMENT_CODES.PHONEPEUPI.toUpperCase(),
    INAPP_UPI: PAYMENT_CODES.INAPPUPI.toUpperCase(),
};

export const ALWAYS_POLL_PAYMENT_METHODS = new Set<string>([
    PAYMENT_CODES.UPIINTENT.toUpperCase(),
    PAYMENT_CODES.CRED.toUpperCase(),
]);

export const CONDITIONALLY_POLL_PAYMENT_METHODS = new Set<string>([
    PAYMENT_CODES.JUSPAY.toUpperCase(),
    PAYMENT_CODES.THIRD_PARTY_EMI.toUpperCase(),
    PAYMENT_CODES.AMAZONPAY.toUpperCase(),
    PAYMENT_CODES.AMAZONPAYLATER.toUpperCase(),
]);

export const PAYMENT_METHOD_CODE_MAP: { [index: string]: string | undefined } = {
    CASH: VALID_PAYMENT_METHODS.COD,
    JUSPAY: VALID_PAYMENT_METHODS.CARD,
    JUSPAY_NEW_CARD: VALID_PAYMENT_METHODS.NEW_CARD,
    PAYLATER_LAZYPAY: VALID_PAYMENT_METHODS.PAYLATER,
    [PAYMENT_CODES.NETBANKING]: VALID_PAYMENT_METHODS.NETBANKING,
    AMAZONPAYWEB: VALID_PAYMENT_METHODS.WALLET,
    AMAZONPAY: VALID_PAYMENT_METHODS.WALLET,
    AMAZONPAYLATER: VALID_PAYMENT_METHODS.PAYLATER,
    FREECHARGE: VALID_PAYMENT_METHODS.WALLET,
    "FREECHARGE-SSO": VALID_PAYMENT_METHODS.WALLET,
    MOBIKWIK: VALID_PAYMENT_METHODS.WALLET,
    "MOBIKWIK-SSO": VALID_PAYMENT_METHODS.WALLET,
    PAYTM: VALID_PAYMENT_METHODS.WALLET,
    "PAYTM-SSO": VALID_PAYMENT_METHODS.WALLET,
    PHONEPE: VALID_PAYMENT_METHODS.WALLET,
    UPICOLLECT: VALID_PAYMENT_METHODS.UPI,
    INAPP_UPI: VALID_PAYMENT_METHODS.INAPP_UPI,
    MMT: VALID_PAYMENT_METHODS.MMT,
};
